/**
 * @param {string | undefined} [className]
 * @returns {React.ReactElement}
 */
const CompanyLogoQuironSalud = ({ className }) => (
  <svg
    className={className}
    version="1.1"
    viewBox="182.59 154.5 1379.04 285"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    imageRendering="optimizeQuality"
    fillRule="evenodd"
    clipRule="evenodd"
  >
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#00b1a9"
        d="M 298.5,243.5 C 298.5,289.833 298.5,336.167 298.5,382.5C 296.5,382.5 294.5,382.5 292.5,382.5C 241.62,374.121 207.12,345.788 189,297.5C 173.409,243.019 186.242,196.519 227.5,158C 229.344,156.818 231.177,155.651 233,154.5C 265.286,168.121 286.286,191.788 296,225.5C 297.549,231.409 298.382,237.409 298.5,243.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.81 }}
        fill="#d84157"
        d="M 352.5,190.5 C 353.601,189.402 354.934,189.235 356.5,190C 359.447,192.436 361.78,195.269 363.5,198.5C 360.703,196.205 358.036,193.705 355.5,191C 354.552,190.517 353.552,190.351 352.5,190.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#df3e52"
        d="M 352.5,190.5 C 353.552,190.351 354.552,190.517 355.5,191C 358.036,193.705 360.703,196.205 363.5,198.5C 364.167,198.5 364.5,198.833 364.5,199.5C 364.427,201.027 365.094,202.027 366.5,202.5C 366.427,204.027 367.094,205.027 368.5,205.5C 368.427,207.027 369.094,208.027 370.5,208.5C 383.1,233.674 381.933,258.341 367,282.5C 366.292,283.381 365.458,284.047 364.5,284.5C 363.094,284.973 362.427,285.973 362.5,287.5C 353.162,298.838 341.162,305.505 326.5,307.5C 325.5,307.5 324.5,307.5 323.5,307.5C 323.5,282.167 323.5,256.833 323.5,231.5C 323.789,225.328 325.456,219.662 328.5,214.5C 329.906,214.027 330.573,213.027 330.5,211.5C 330.328,210.508 330.662,209.842 331.5,209.5C 332.906,209.027 333.573,208.027 333.5,206.5C 333.5,205.833 333.833,205.5 334.5,205.5C 335.906,205.027 336.573,204.027 336.5,202.5C 336.833,201.5 337.5,200.833 338.5,200.5C 341.089,199.581 343.089,197.914 344.5,195.5C 346.027,195.573 347.027,194.906 347.5,193.5C 349.027,193.573 350.027,192.906 350.5,191.5C 350.842,190.662 351.508,190.328 352.5,190.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.992 }}
        fill="#da4055"
        d="M 350.5,191.5 C 350.027,192.906 349.027,193.573 347.5,193.5C 347.973,192.094 348.973,191.427 350.5,191.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.992 }}
        fill="#da4055"
        d="M 347.5,193.5 C 347.027,194.906 346.027,195.573 344.5,195.5C 344.973,194.094 345.973,193.427 347.5,193.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.992 }}
        fill="#da4055"
        d="M 344.5,195.5 C 343.089,197.914 341.089,199.581 338.5,200.5C 339.911,198.086 341.911,196.419 344.5,195.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.816 }}
        fill="#d94056"
        d="M 364.5,199.5 C 365.906,199.973 366.573,200.973 366.5,202.5C 365.094,202.027 364.427,201.027 364.5,199.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.941 }}
        fill="#d94156"
        d="M 336.5,202.5 C 336.573,204.027 335.906,205.027 334.5,205.5C 334.427,203.973 335.094,202.973 336.5,202.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.82 }}
        fill="#d94056"
        d="M 366.5,202.5 C 367.906,202.973 368.573,203.973 368.5,205.5C 367.094,205.027 366.427,204.027 366.5,202.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.298 }}
        fill="#d84157"
        d="M 368.5,205.5 C 369.906,205.973 370.573,206.973 370.5,208.5C 369.094,208.027 368.427,207.027 368.5,205.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.714 }}
        fill="#d84157"
        d="M 333.5,206.5 C 333.573,208.027 332.906,209.027 331.5,209.5C 331.427,207.973 332.094,206.973 333.5,206.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.973 }}
        fill="#d94056"
        d="M 330.5,211.5 C 330.573,213.027 329.906,214.027 328.5,214.5C 328.427,212.973 329.094,211.973 330.5,211.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.906 }}
        fill="#13afa8"
        d="M 1276.5,221.5 C 1276.83,221.5 1277.17,221.5 1277.5,221.5C 1277.5,275.167 1277.5,328.833 1277.5,382.5C 1284.17,382.5 1290.83,382.5 1297.5,382.5C 1297.5,382.833 1297.5,383.167 1297.5,383.5C 1290.5,383.5 1283.5,383.5 1276.5,383.5C 1276.5,329.5 1276.5,275.5 1276.5,221.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#00b2a8"
        d="M 1277.5,221.5 C 1284.17,221.5 1290.83,221.5 1297.5,221.5C 1297.5,275.167 1297.5,328.833 1297.5,382.5C 1290.83,382.5 1284.17,382.5 1277.5,382.5C 1277.5,328.833 1277.5,275.167 1277.5,221.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.529 }}
        fill="#21aea9"
        d="M 1276.5,221.5 C 1283.65,220.508 1290.98,220.175 1298.5,220.5C 1298.83,275.003 1298.5,329.336 1297.5,383.5C 1297.5,383.167 1297.5,382.833 1297.5,382.5C 1297.5,328.833 1297.5,275.167 1297.5,221.5C 1290.83,221.5 1284.17,221.5 1277.5,221.5C 1277.17,221.5 1276.83,221.5 1276.5,221.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#02b1a9"
        d="M 1560.5,376.5 C 1536.54,383.678 1512.2,385.178 1487.5,381C 1469.83,374.654 1459.33,362.154 1456,343.5C 1451.67,323.475 1453.67,304.142 1462,285.5C 1472.51,271.328 1486.68,264.161 1504.5,264C 1515.61,263.22 1526.27,264.72 1536.5,268.5C 1537.57,269.434 1538.9,269.768 1540.5,269.5C 1540.5,253.5 1540.5,237.5 1540.5,221.5C 1547.17,221.5 1553.83,221.5 1560.5,221.5C 1560.5,273.167 1560.5,324.833 1560.5,376.5 Z M 1539.5,288.5 C 1539.82,312.908 1539.49,337.241 1538.5,361.5C 1491.33,373.826 1470.83,355.826 1477,307.5C 1481.98,290.56 1493.48,282.227 1511.5,282.5C 1521.16,283.098 1530.49,285.098 1539.5,288.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.612 }}
        fill="#1eafa9"
        d="M 1560.5,376.5 C 1560.5,324.833 1560.5,273.167 1560.5,221.5C 1553.83,221.5 1547.17,221.5 1540.5,221.5C 1540.5,237.5 1540.5,253.5 1540.5,269.5C 1538.9,269.768 1537.57,269.434 1536.5,268.5C 1537.5,268.5 1538.5,268.5 1539.5,268.5C 1539.5,252.5 1539.5,236.5 1539.5,220.5C 1546.83,220.5 1554.17,220.5 1561.5,220.5C 1561.83,272.669 1561.5,324.669 1560.5,376.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.953 }}
        fill="#4a4f53"
        d="M 652.5,228.5 C 659.833,228.5 667.167,228.5 674.5,228.5C 674.5,235.5 674.5,242.5 674.5,249.5C 667.167,249.5 659.833,249.5 652.5,249.5C 652.5,242.5 652.5,235.5 652.5,228.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.906 }}
        fill="#da4056"
        d="M 323.5,231.5 C 323.5,256.833 323.5,282.167 323.5,307.5C 324.5,307.5 325.5,307.5 326.5,307.5C 325.432,308.434 324.099,308.768 322.5,308.5C 322.169,282.661 322.502,256.995 323.5,231.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.97 }}
        fill="#4a4f53"
        d="M 828.5,247.5 C 837.839,247.334 847.173,247.5 856.5,248C 850.985,253.348 845.652,258.848 840.5,264.5C 861.159,268.327 874.326,280.327 880,300.5C 883.576,317.254 883.242,333.921 879,350.5C 873.814,366.678 862.981,376.844 846.5,381C 791.003,390.835 765.17,367.668 769,311.5C 772.367,282.633 788.534,266.633 817.5,263.5C 821.177,258.138 824.843,252.804 828.5,247.5 Z M 821.5,281.5 C 844.234,280.41 857.068,291.077 860,313.5C 861.484,325.504 860.151,337.17 856,348.5C 847.4,362.49 834.9,367.99 818.5,365C 801.556,361.384 792.389,350.884 791,333.5C 789.195,320.652 790.862,308.318 796,296.5C 802.07,287.22 810.57,282.22 821.5,281.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.684 }}
        fill="#1daea9"
        d="M 298.5,243.5 C 299.499,289.997 299.832,336.664 299.5,383.5C 296.941,383.802 294.607,383.468 292.5,382.5C 294.5,382.5 296.5,382.5 298.5,382.5C 298.5,336.167 298.5,289.833 298.5,243.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.977 }}
        fill="#4a4f53"
        d="M 439.5,263.5 C 457.662,263.559 475.662,265.226 493.5,268.5C 493.5,325.5 493.5,382.5 493.5,439.5C 486.167,439.5 478.833,439.5 471.5,439.5C 471.833,419.156 471.5,398.822 470.5,378.5C 453.03,384.575 435.364,385.075 417.5,380C 401.195,373.564 391.362,361.731 388,344.5C 384.675,327.363 385.675,310.363 391,293.5C 395.833,282 404,273.833 415.5,269C 423.391,266.059 431.391,264.226 439.5,263.5 Z M 436.5,282.5 C 448.235,282.184 459.901,282.851 471.5,284.5C 471.667,309.169 471.5,333.836 471,358.5C 424.778,374.396 404.112,358.063 409,309.5C 412.133,294.199 421.299,285.199 436.5,282.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.966 }}
        fill="#4a4f53"
        d="M 518.5,263.5 C 525.833,263.5 533.167,263.5 540.5,263.5C 540.333,290.835 540.5,318.169 541,345.5C 543.873,358.792 552.206,365.459 566,365.5C 579.176,364.557 590.509,359.557 600,350.5C 600.5,321.502 600.667,292.502 600.5,263.5C 607.833,263.5 615.167,263.5 622.5,263.5C 622.5,303.5 622.5,343.5 622.5,383.5C 617.167,383.5 611.833,383.5 606.5,383.5C 605.787,378.646 604.454,373.98 602.5,369.5C 583.185,383.164 562.185,386.664 539.5,380C 526.499,373.185 519.666,362.352 519,347.5C 518.5,319.502 518.333,291.502 518.5,263.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.981 }}
        fill="#4a4f53"
        d="M 652.5,263.5 C 659.833,263.5 667.167,263.5 674.5,263.5C 674.5,303.5 674.5,343.5 674.5,383.5C 667.167,383.5 659.833,383.5 652.5,383.5C 652.5,343.5 652.5,303.5 652.5,263.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.968 }}
        fill="#4a4f53"
        d="M 705.5,263.5 C 710.5,263.5 715.5,263.5 720.5,263.5C 721.505,268.522 722.672,273.522 724,278.5C 734.401,268.387 746.901,263.387 761.5,263.5C 761.5,269.833 761.5,276.167 761.5,282.5C 748.176,282.08 737.01,286.747 728,296.5C 727.5,325.498 727.333,354.498 727.5,383.5C 720.167,383.5 712.833,383.5 705.5,383.5C 705.5,343.5 705.5,303.5 705.5,263.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.975 }}
        fill="#4a4f53"
        d="M 905.5,263.5 C 910.5,263.5 915.5,263.5 920.5,263.5C 921.505,268.522 922.672,273.522 924,278.5C 943.18,263.473 964.346,259.973 987.5,268C 999.638,274.098 1006.47,283.932 1008,297.5C 1008.5,326.165 1008.67,354.831 1008.5,383.5C 1001.17,383.5 993.833,383.5 986.5,383.5C 986.967,354.45 986.467,325.45 985,296.5C 980.265,286.459 972.265,281.793 961,282.5C 948.103,282.784 937.103,287.451 928,296.5C 927.5,325.498 927.333,354.498 927.5,383.5C 920.167,383.5 912.833,383.5 905.5,383.5C 905.5,343.5 905.5,303.5 905.5,263.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#03b1a9"
        d="M 1123.5,269.5 C 1124.12,275.926 1123.45,281.926 1121.5,287.5C 1104.11,282.561 1086.44,281.061 1068.5,283C 1056.06,284.43 1050.89,291.264 1053,303.5C 1055.03,308.867 1058.87,312.033 1064.5,313C 1077.21,313.126 1089.87,313.793 1102.5,315C 1119.94,319.28 1128.61,330.447 1128.5,348.5C 1129.13,362.096 1123.46,371.929 1111.5,378C 1096.57,383.092 1081.23,384.759 1065.5,383C 1055.47,382.406 1045.8,380.573 1036.5,377.5C 1036.18,371.31 1036.51,365.31 1037.5,359.5C 1053.84,364.223 1070.51,366.057 1087.5,365C 1104.77,362.941 1109.94,354.108 1103,338.5C 1100.91,337.206 1098.75,336.039 1096.5,335C 1082.5,334 1068.5,333 1054.5,332C 1038.33,326.86 1030.66,315.694 1031.5,298.5C 1031.11,284.735 1037.11,274.902 1049.5,269C 1074.2,261.977 1098.86,262.144 1123.5,269.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#03b1a9"
        d="M 1157.5,286.5 C 1156.51,281.025 1156.18,275.358 1156.5,269.5C 1179.77,261.862 1203.1,261.696 1226.5,269C 1236.93,273.095 1243.43,280.595 1246,291.5C 1246.5,322.165 1246.67,352.832 1246.5,383.5C 1242.12,383.826 1237.78,383.492 1233.5,382.5C 1231.65,378.779 1229.31,375.446 1226.5,372.5C 1207.33,384.047 1187,386.547 1165.5,380C 1151.88,373.607 1145.21,362.774 1145.5,347.5C 1146.38,325.122 1158.04,312.956 1180.5,311C 1194.92,310.038 1209.25,310.538 1223.5,312.5C 1228.15,298.646 1223.82,289.146 1210.5,284C 1204.57,282.676 1198.57,281.842 1192.5,281.5C 1180.68,282.193 1169.01,283.859 1157.5,286.5 Z M 1221.5,329.5 C 1222.21,330.404 1223.21,330.737 1224.5,330.5C 1224.5,338.5 1224.5,346.5 1224.5,354.5C 1209.06,365.352 1192.39,367.852 1174.5,362C 1167.18,354.93 1165.68,346.763 1170,337.5C 1173.54,332.478 1178.38,329.644 1184.5,329C 1196.85,328.381 1209.18,328.548 1221.5,329.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.439 }}
        fill="#22aea9"
        d="M 1349.5,264.5 C 1342.5,264.5 1335.5,264.5 1328.5,264.5C 1328.5,291.5 1328.5,318.5 1328.5,345.5C 1327.5,318.338 1327.17,291.005 1327.5,263.5C 1335.02,263.175 1342.35,263.508 1349.5,264.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#01b1a9"
        d="M 1349.5,264.5 C 1349.33,290.835 1349.5,317.169 1350,343.5C 1351.85,358.365 1360.35,365.699 1375.5,365.5C 1388.59,364.286 1399.92,359.286 1409.5,350.5C 1410.5,322.005 1410.83,293.338 1410.5,264.5C 1417.17,264.5 1423.83,264.5 1430.5,264.5C 1430.5,303.833 1430.5,343.167 1430.5,382.5C 1425.19,383.026 1420.19,382.36 1415.5,380.5C 1414.62,376.654 1413.29,372.988 1411.5,369.5C 1392.18,383.164 1371.18,386.664 1348.5,380C 1334.77,372.724 1328.11,361.224 1328.5,345.5C 1328.5,318.5 1328.5,291.5 1328.5,264.5C 1335.5,264.5 1342.5,264.5 1349.5,264.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.529 }}
        fill="#1dafa9"
        d="M 1415.5,380.5 C 1420.19,382.36 1425.19,383.026 1430.5,382.5C 1430.5,343.167 1430.5,303.833 1430.5,264.5C 1423.83,264.5 1417.17,264.5 1410.5,264.5C 1410.83,293.338 1410.5,322.005 1409.5,350.5C 1409.5,321.5 1409.5,292.5 1409.5,263.5C 1416.83,263.5 1424.17,263.5 1431.5,263.5C 1431.5,303.5 1431.5,343.5 1431.5,383.5C 1426.17,383.5 1420.83,383.5 1415.5,383.5C 1415.5,382.5 1415.5,381.5 1415.5,380.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.341 }}
        fill="#23aea9"
        d="M 1123.5,269.5 C 1124.49,275.645 1124.82,281.978 1124.5,288.5C 1123.21,288.737 1122.21,288.404 1121.5,287.5C 1123.45,281.926 1124.12,275.926 1123.5,269.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.937 }}
        fill="#13afa9"
        d="M 1156.5,269.5 C 1156.18,275.358 1156.51,281.025 1157.5,286.5C 1157.44,287.043 1157.11,287.376 1156.5,287.5C 1155.18,281.346 1155.18,275.346 1156.5,269.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.008 }}
        fill="#d74158"
        d="M 364.5,284.5 C 364.573,286.027 363.906,287.027 362.5,287.5C 362.427,285.973 363.094,284.973 364.5,284.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.863 }}
        fill="#16afa9"
        d="M 1539.5,288.5 C 1540.17,300.495 1540.5,312.662 1540.5,325C 1540.5,337.519 1539.83,349.686 1538.5,361.5C 1539.49,337.241 1539.82,312.908 1539.5,288.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.122 }}
        fill="#26aea9"
        d="M 1221.5,329.5 C 1222.83,329.5 1224.17,329.5 1225.5,329.5C 1225.83,338.017 1225.49,346.35 1224.5,354.5C 1224.5,346.5 1224.5,338.5 1224.5,330.5C 1223.21,330.737 1222.21,330.404 1221.5,329.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.119 }}
        fill="#27aea8"
        d="M 1037.5,359.5 C 1036.51,365.31 1036.18,371.31 1036.5,377.5C 1035.18,371.322 1035.18,364.988 1036.5,358.5C 1037.11,358.624 1037.44,358.957 1037.5,359.5 Z"
      />
    </g>
  </svg>
);

export default CompanyLogoQuironSalud;
